export default __webpack_public_path__ + "static/media/CloseCircle.5bac713d.svg";